import { PhoneBrand } from './phone-brand';
import { PhoneModel } from './phone-model';

export class Phone {
  constructor(private _brand: PhoneBrand = null,
    private _model: PhoneModel = null) {
  }

  get brand(): PhoneBrand {
    return this._brand;
  }

  get model(): PhoneModel {
    return this._model;
  }

  withBrand(brand: PhoneBrand): Phone {
    return new Phone(
      brand,
      this._model
    );
  }

  withModel(model: PhoneModel): Phone {
    return new Phone(
      this._brand,
      model
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/core/model/phone.ts